<template>
  <section class="mt-5">
    <h2>登録申込</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">申込登録</li>
        <li class="here px-3">内容確認</li>
        <li class="px-3">商品注文</li>
        <li class="px-3">カート確認</li>
        <li class="px-3">お届け/お支払</li>
        <li class="px-3">最終確認</li>
        <li class="px-3">申込完了</li>
      </ul>
    </div>
    <h3 class="form-ttl">申込者情報確認</h3>
    <p>以下の内容でよろしければ次へ進むを押してください。</p>
    <div class="form-member my-5">
      <div class="inner">
        <form>
          <dl id="dlConfirm">
            <dt>氏名</dt>
            <dd>真奈&emsp;美須子</dd>
            <dt>氏名<span class="fs-08">（フリガナ）</span></dt>
            <dd>マナ&emsp;ビスコ</dd>
            <dt>性別</dt>
            <dd>女性</dd>
            <dt>配偶者</dt>
            <dd>無し</dd>
            <dt>生年月日</dt>
            <dd>0000/00/00</dd>
            <dt>郵便番号</dt>
            <dd>2790032</dd>
            <dt>住所</dt>
            <dd>千葉県浦安市千鳥15-9</dd>
            <dt>住所<span class="fs-08">（フリガナ）</span></dt>
            <dd>チバケンウラヤスシチドリ15バンチ8</dd>
            <dt>住所<span class="fs-08">（建物名）</span></dt>
            <dd>マナビスマンション101</dd>
            <dt>住所<span class="fs-08">（その他）</span></dt>
            <dd>浦安舞子方</dd>
            <dt>配送時連絡先</dt>
            <dd>携帯電話番号</dd>
            <dt>携帯電話番号</dt>
            <dd>0888888888</dd>
            <dt>自宅電話番号</dt>
            <dd></dd>
            <dt>FAX番号</dt>
            <dd></dd>
            <dt>パスワード</dt>
            <dd>password0000</dd>
            <dt>当社からの広告等のメール・SMS・FAX送信</dt>
            <dd>承諾しない</dd>
          </dl>
          <div
            class="box-p-20 d-flex justify-content-around text-center column_sp"
          >
            <div>
              <router-link
                :to="{ path: '/mock/influencer/registration' }"
                class="btn d-inline-block mt-5"
              >
                入力画面へ戻る
              </router-link>
            </div>
            <div>
              <router-link
                :to="{ path: '/mock/influencer/order' }"
                class="btn d-inline-block mt-5"
              >
                次へ進む
              </router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ mc-info@manavis-cosme.co.jp
    </p>
  </div>
</template>
<script>

export default {
  mounted() {
    window.scroll(0, 0);
  }
};

</script>
